import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import mediaServices from "../../../services/media.service";

// initial values
const initialState = {
  media: [],
  loading: false,
  error: null,
};

// get all media

export const getAllMedia = createAsyncThunk(
  "media/getAll",
  async (_, { rejectWithValue }) => {
    try {
      const response = await mediaServices.getAll();
      return response.data?.data;
    } catch (error) {
      console.error("Error fetching Media:", error.message);
      return rejectWithValue(error.message);
    }
  }
);

// crete media

export const createMedia = createAsyncThunk(
  "media/create",
  async ({ username, phoneNumber }, { rejectWithValue }) => {
    try {
      const mediaData = { username, phoneNumber };
      await mediaServices.create(mediaData);
      const response = await mediaServices.getAll();
      return response.data?.data;
    } catch (error) {
      console.error("Error creating Media:", error.message);
      return rejectWithValue(error.message);
    }
  }
);

// delete media

export const deleteMedia = createAsyncThunk(
  "media/delete",
  async (mediaId, { rejectWithValue }) => {
    try {
      await mediaServices.delete(mediaId);
      return mediaId;
    } catch (error) {
      console.error("Error deleting Media:", error.message);
      return rejectWithValue(error.message);
    }
  }
);
export const addEventsBanner = async (data) => {
  try {
    const response = await mediaServices.addEvents(data);
    return response.data.message;
  } catch (err) {
    return err.response.data.message;
  }
};
export const getEventsBanner = async () => {
  try {
    const response = await mediaServices.getEvents();
    return response.data.banner;
  } catch (err) {
    return err.response.data.message;
  }
};
export const deleteEventsBanner = async (id) => {
  try {
    const response = await mediaServices.deleteEventBanner(id);
    console.log("event",response.data)
    return response.data.message;
  } catch (err) {
    return err.response.data.message;
  }
};

// update media

export const updateMedia = createAsyncThunk(
  "media/update",
  async ({ id, username, phoneNumber }, { rejectWithValue }) => {
    try {
      const updatedMediaData = { username, phoneNumber };
      const response = await mediaServices.update(id, updatedMediaData);
      return response.data?.data;
    } catch (error) {
      console.error("Error updating Media:", error.message);
      return rejectWithValue(error.message);
    }
  }
);

// create slice
export const mediaSlice = createSlice({
  name: "media",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder

      // getall media
      .addCase(getAllMedia.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAllMedia.fulfilled, (state, action) => {
        state.loading = false;
        state.media = action.payload;
        state.error = null;
      })
      .addCase(getAllMedia.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // create meadia
      .addCase(createMedia.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createMedia.fulfilled, (state, action) => {
        state.loading = false;
        state.media = [...state.media, action.payload];
        state.error = null;
      })
      .addCase(createMedia.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // update media
      .addCase(updateMedia.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateMedia.fulfilled, (state, action) => {
        state.loading = false;
        const updatedMedia = state.media.map((media) =>
          media.id === action.payload.id ? action.payload : media
        );
        state.media = updatedMedia;
        state.error = null;
      })
      .addCase(updateMedia.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // delete media
      .addCase(deleteMedia.pending, (state) => {
        // state.loading = true;
        state.error = null;
      })
      .addCase(deleteMedia.fulfilled, (state, action) => {
        state.loading = false;
        state.media = state.media.filter(
          (media) => media.id !== action.payload
        );
        state.error = null;
      })
      .addCase(deleteMedia.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

// selectors
export const selectLoading = (state) => state.media.loading;
export const selectAllmedia = (state) => state.media.media;
export const selectMediaErrors = (state) => state.media.error;

export default mediaSlice.reducer;
